import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography, Rating } from '@mui/material';

const ReceiverNeedsProfile = ({ categories, initialValues = {}, isMobileView = false }) => {
  const [newValues, setNewValues] = useState({});
  const { control } = useFormContext();

  const initialValueChanged = (categoryId) => {
    const differingKeys = Object.keys(newValues).filter(
      (key) => initialValues.hasOwnProperty(key) && newValues[key] !== initialValues[key]
    );
    const keyDiffers = differingKeys.find((k) => k === categoryId);
    return keyDiffers;
  };

  return (
    <Box>
      <Typography variant="h6">What types of food are most useful to your agency?</Typography>
      <Typography variant="caption">
        Rank categories according to need. This will be used to route food more effectively, but is not a guarantee that
        you will receive the food ranked highest.
      </Typography>
      <Box
        sx={{
          columns: isMobileView ? '2 auto' : '3 auto',
          maxWidth: '700px',
          marginTop: 2,
        }}
      >
        {categories.map((category) => (
          <Box mb={3} key={category.id} sx={{ display: 'inline-block' }}>
            <Typography
              sx={{ fontWeight: initialValueChanged(category.id.toString()) ? 'bold' : 'normal' }}
              component="legend"
            >
              {category.name}
            </Typography>
            <Controller
              name={`needs_profile.${category.id.toString()}`}
              control={control}
              as={(props) => (
                <Rating
                  name={category.name}
                  value={props.value || 0}
                  onChange={(e, newValue) => {
                    props.onChange(newValue !== null ? newValue : 0)
                    setNewValues((prev) => ({ ...prev, [category.id]: newValue !== null ? newValue : 0 }))
                  }}
              />
              )}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ReceiverNeedsProfile;
